import React from 'react';

const Loading = () => {
    return (
        <div className="spinner-container">
            <div className="loading-spinner"></div>
        </div>
    )
}

export default Loading;